import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://missingconst.internal:8001';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  console.log("api CONST url:"+API_URL);
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  login: (email, password) => api.post('/api/auth/login', { email, password }),
  register: (email, password, name) => api.post('/api/auth/register', { email, password, name }),
  getProfile: () => api.get('/api/auth/profile'),
};

// Message APIs
export const messageAPI = {
  getMessages: (params = {}) => api.get('/api/messages', { params }),
  getInbox: (params = {}) => api.get('/api/messages', { params: { ...params, type: 'inbox' } }),
  getAlerts: (params = {}) => api.get('/api/messages', { params: { ...params, type: 'alert' } }),
  getMessage: (id) => api.get(`/api/messages/${id}`),
  updateMessage: (id, data) => api.patch(`/api/messages/${id}`, data),
  getSummary: () => api.get('/api/messages/summary'),
};

// Admin APIs
export const adminAPI = {
  getStats: () => api.get('/api/admin/stats'),
  getUsers: () => api.get('/api/admin/users'),
  createMessage: (data) => api.post('/api/admin/messages', data),
};

// Health API
export const healthAPI = {
  check: () => api.get('/api/health'),
};

export default api;
